module.exports = __webpack_public_path__ + "img/card-4.db92e3d0.png";